module.exports = __webpack_public_path__ + "img/sephotaSet2.2a97eca5.jpg";